import { Icon } from "@chakra-ui/react";
import { TIconComponent } from "./icon-component.types";

export const IconThreeDots: TIconComponent = props => (
    <Icon viewBox="0 0 18 4" {...props}>
        <circle cx="2" cy="2" r="2" fill="#484F51" />
        <circle cx="9" cy="2" r="2" fill="#484F51" />
        <circle cx="16" cy="2" r="2" fill="#484F51" />
    </Icon>
);
